import axios from "axios";
import { SERVER_URL } from "../const";
import Qs from 'qs';


export const iecWiseBrcDetailsService = async (iec_no, filters) => {
  const token = localStorage.getItem('token');
  try {
    let queryParams = `iec_no=${iec_no}`;

    if (filters.from_date && filters.to_date) {
      queryParams += `&from_date=${filters.from_date}&to_date=${filters.to_date}`;
    }

    if (filters.bill_no) {
      queryParams += `&bill_no=${filters.bill_no}`;
    }
    // Make a GET request to the API endpoint using Axios
    const response = await axios.get(`${SERVER_URL}/get-brc-details?${queryParams}`, {
      params: {
        br_code: filters.br_code && filters.br_code.length > 0
          ? filters.br_code
          : undefined
      },
      paramsSerializer: params => {
        // This removes the brackets []
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      },
      headers: { 'Authorization': `Bearer ${token}` }
    });

    return response.data; // You can modify this based on your response structure
  } catch (error) {
    // Handle errors
    console.error('Error:', error);
    throw error; // Rethrow the error if needed
  }
};
